import { contentsChecker } from 'src/features/retails/hooks'
import { Brand, DocumentContentGenerator, I18NText, State, StateObj } from 'src/types'
import { genEmbroideryCells } from '../embroidery'
import { en2JaBasePartsTranslates } from 'src/features/brands/atoms/us/constants/bases'
import { ko2JaEmbroideryPartsTranslates } from 'src/features/brands/atoms/korea/constants/embroidery'
import { getYellStoryOptionalEmbroideryCells } from 'src/features/brands/yellStory/simulatedSpecification'
import { getRagDeLionOptionalEmbroideryCells } from 'src/features/brands/ragdelion/simulatedSpecification'

const genEmbroideryPdfHeader = (index: number) => ({
  text: `刺繍設定${index + 1}`,
  style: { fontSize: 11 },
  margin: [0, 8, 0, 4]
})

export const embroiderySettings = (state: State, genCellContent: DocumentContentGenerator, t: I18NText): any => {
  const { isUsContents } = contentsChecker(state.dominantArm)

  const cellsList = state.embroideries.map((e) => genEmbroideryCells(e, t))
  const existEmbroidery = state.embroideries.some((e) => e.content.length > 0)
  if (!existEmbroidery) {
    return [
      genEmbroideryPdfHeader(0),
      {
        text: `通常刺繍なし`,
        style: { fontSize: 8 },
        margin: [0, 8, 0, 4]
      }
    ]
  }
  const formatted = cellsList.map((cells) => {
    const translated = cells.map((cell) => {
      const cellHead = cell.head
      const cellLabel = cell.label
      const japaneseLabel = isUsContents
        ? en2JaBasePartsTranslates.find((x) => x?.en === cellLabel)?.japanese
        : ko2JaEmbroideryPartsTranslates.find((x) => x?.korea === cellLabel)?.japanese
      const japaneseHead = isUsContents
        ? en2JaBasePartsTranslates.find((x) => x?.en === cellHead)?.japanese
        : ko2JaEmbroideryPartsTranslates.find((x) => x?.korea === cellHead)?.japanese
      const label = japaneseLabel ?? cellLabel
      // console.log({ japaneseHead, cellHead, fuga: japaneseHead ?? cellHead })

      const head = japaneseHead ?? cellHead
      return { ...cell, label, head }
    })
    // const remaining = cells.length % 3 // 配列要素数合計を3の倍数で割った時の余り
    // const dummy = { head: '', label: '', value: '' }
    return translated
  })
  // console.log({ formatted })
  const chunked = formatted.map((cells) =>
    cells.reduce((acc, curr, i) => {
      if (i % 2 === 0) {
        acc.push([curr])
      } else {
        acc[acc.length - 1].push(curr)
      }
      return acc
    }, [])
  )
  return chunked.map((cellLists, i) => [
    genEmbroideryPdfHeader(i),
    {
      table: {
        widths: '50%',
        body: cellLists.map((cellList) => cellList.map((cell) => genCellContent(cell.head, cell.label || '--', 'right')))
      }
    }
  ])
}

export const getOriginalEmbroideryCells = (state: State, brand: Brand) => {
  switch (brand) {
    case 'yellStory':
      return getYellStoryOptionalEmbroideryCells(state)
    case 'ragdelion':
      return getRagDeLionOptionalEmbroideryCells(state)
    default:
      return []
  }
}
